export default "__VITE_ASSET__RTYaTNuU__"